module.exports = __webpack_public_path__ + "static/media/wind-warning.c379f670.svg";